import { getBoardSport, Sport } from "@sportactics/board-editing";

import { useSelectBoardType } from "../select-board-type";

// Custom players belong to a sport, and the sport follows the selected board type.
export function useSelectedSport(): Sport | undefined {
  const { boardType } = useSelectBoardType();

  return boardType === undefined ? undefined : getBoardSport(boardType);
}
